















import Vue from 'vue';
import {Device, DeviceType} from "./PortfolioProject";
import DeviceView from "./Device.vue";
import {DeviceViewModel} from "@/components/portfolio/DeviceViewModel";

export default Vue.extend({
  name: "DeviceCollectionView",
  components: {DeviceView},
  props: {
    devices: {
      type: Array as () => Device[],
      required: true,
      default: () => [],
    }
  },
  computed: {
    devicesViewModel: function (): DeviceViewModel[] {
      return this.devices.map(this.getViewModel)
    },
  },
  methods: {
    getViewModel(device: Device): DeviceViewModel {
      return new DeviceViewModel(device);
    },
    isSecond(device: DeviceViewModel): Boolean {
      return this.devices.length > 1 && device.getType() === DeviceType.SMARTPHONE;
    },
  }
})
